import { Controller } from 'stimulus';

const SEARCH_FOCUS_TIMEOUT = 50;

class SearchController extends Controller {
  onTogglerClick() {
    const isExpanded = this.togglerTarget.getAttribute('aria-expanded') === 'true';

    this.togglerTarget.setAttribute('aria-expanded', !isExpanded);

    if (!isExpanded) {
      this.focusInput();
    }
  }

  focusInput() {
    setTimeout(() => {
      this.inputTarget.focus();
    }, SEARCH_FOCUS_TIMEOUT);
  }
}

SearchController.targets = [
  'toggler',
  'form',
  'input',
];

export default SearchController;
